// Browser storage is optional. UI state must still work when access is denied or the disk is full.
export const browserStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): boolean {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch {
      // persistence-best-effort: Browser storage is optional; keep the in-memory state.
      return false;
    }
  },
  removeItem(key: string): boolean {
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch {
      // persistence-best-effort: Optional storage cleanup must not block navigation or logout.
      return false;
    }
  },
};

// Per-node drafts hold family names typed by the signed-in account, so they never outlive the session.
const accountDraftPrefixes = ["awraq:bulk-node-draft:", "awraq:voice-family-draft:"];

export function clearAccountStorage(): void {
  const keys = ["tree-navigation-history", "family-tree:recent-nodes:shared", "awraq-registration-tree-draft"];

  try {
    for (let index = 0; index < window.localStorage.length; index++) {
      const key = window.localStorage.key(index);
      if (key && accountDraftPrefixes.some((prefix) => key.startsWith(prefix))) {
        keys.push(key);
      }
    }
  } catch {
    // Still attempt known keys if enumeration is unavailable.
  }

  keys.forEach((key) => browserStorage.removeItem(key));
}
